import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("directMatching", ["selectedDirectMatching"]),
    isSender() {
      return this.user.idx === this.selectedDirectMatching?.requester?.idx
    },
    isReceiver() {
      return this.user.idx === this.selectedDirectMatching?.requested?.idx
    },
    matchPeople() {
      return this.user.idx == this.selectedDirectMatching?.requester?.idx
        ? this.selectedDirectMatching.requested
        : this.selectedDirectMatching.requester;
    },
    selfAccount() {
      return this.user.idx == this.selectedDirectMatching?.requester?.idx
        ? this.selectedDirectMatching.requester
        : this.selectedDirectMatching.requested;
    },
  },
}
